import React from 'react';
import { useDispatch } from 'react-redux';
import { toggleTimerManager, showTimerManager, resetTimerManagerHiddenState } from '../../redux/Slices/timerSlice';
import { useRunningTimers, useTimerManager } from '../../hooks/useTimer';
import Timer from '../icons/Timer';
import './scss/TimerToggleButton.scss';

const TimerToggleButton = () => {
    const dispatch = useDispatch();
    const runningTimers = useRunningTimers();
    const { isVisible } = useTimerManager();

    // Only show toggle button if there are running timers
    if (runningTimers.length === 0) {
        return null;
    }

    const handleToggle = () => {
        if (isVisible) {
            dispatch(toggleTimerManager());
        } else {
            dispatch(showTimerManager());
            dispatch(resetTimerManagerHiddenState());
        }
    };

    return (
        <button
            className={`timer-toggle-button ${isVisible ? 'active' : ''}`}
            onClick={handleToggle}
            title={`${isVisible ? 'Hide' : 'Show'} Timer Manager (${runningTimers.length} running)`}
        >
            <Timer size={20} color="#fff" />
            <span className="timer-count">{runningTimers.length}</span>

            {/* Show pluse if there are atleast timers status is 'running' */}
            {runningTimers.some(timer => timer.timerStatus === 'running') && (
                <div className="pulse-ring"></div>
            )}

        </button>
    );
};

export default TimerToggleButton;
